import authService from './authService'
import axios from 'axios'

const URL_MAX_LENGTH = 1724

export default {
  query (sql) {
    const { api_base_url: base, apikey } = authService.getAuth()
    const url = `${base}/api/v2/sql?api_key=${apikey}`
    const getUrl = `${url}&q=${encodeURIComponent(sql)}`
    if (getUrl.length > URL_MAX_LENGTH) {
      return axios.post(url, { q: sql }).then(res => res.data)
    } else {
      return axios.get(getUrl).then(res => res.data)
    }
  }
}
